import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Customer } from 'app/models/customer.model';
import { User } from 'app/models/user.model';
import { CustomerService } from 'app/services/customer/customer.service';
declare const swal: any;

@Component({
  selector: 'app-edit-customer',
  templateUrl: './edit-customer.component.html',
  styleUrls: ['./edit-customer.component.css']
})
export class EditCustomerComponent implements OnInit {

  customer: Customer;
  id: number;
  user: User;

  constructor(private dialogRef: MatDialogRef<EditCustomerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private customerService: CustomerService) { }

  ngOnInit(): void {
    this.id = this.data.id;
    this.user = JSON.parse(sessionStorage.getItem('loggedUser'));
  }

  customerForm = this.formBuilder.group({
    customerName: [this.data.customerName, Validators.required],
    name: [this.data.name, Validators.required],
    phone: [this.data.phone, Validators.required],
    mobile: [this.data.mobile]
  });

  cancel(){
    this.dialogRef.close();
  }

  saveCustomer(){
    try {
      this.customer = this.customerForm.value;
      this.customer.id = this.id;
      this.customer.enterprise = this.user.databaseId;
      if(this.customerForm.status === 'INVALID'){
        this.openAlert(0);
      }else{
        this.customerService.saveCustomer(this.customer).subscribe(customerSaved => {
          console.log('customer saved!');
          this.openAlert(1);
          this.dialogRef.close(customerSaved);
        })
      }
    } catch (error) {
      console.error(error);
    }
  }

  openAlert(type){
    switch (type) {
      case 1:
        swal({
          title: 'Guardado correctamente',
          text: 'Presiona OK para continuar',
          type: 'success',
          timer: 3000,
          showConfirmButton: false
        })
        break;
      case 0:
        swal({
          title: 'Atención',
          text: 'Debes llenar todos los campos requeridos',
          type: 'warning',
          confirmButtonClass: 'btn btn-danger'
        })
    }
  }

}
